import React from 'react';
import PropTypes from 'prop-types';

import Tooltip from '@dc/ui-library/src/molecules/Tooltip/Tooltip';

export default function LocationSearchErrorMessage(props) {

  return (
    <div className={'dc-location-search-error-message'}>
      <Tooltip textAlign={'center'} type={'negative'}>
        <span dangerouslySetInnerHTML={{ __html: `${props.errorMessageLabel} ` }} />
        <a
          className={'tooltip-link'}
          href={'#try-again'}
          onClick={props.onLinkClick}
        >
          {props.linkLabel}
        </a>
      </Tooltip>
    </div>

  );
}

LocationSearchErrorMessage.propTypes = {
  errorMessageLabel: PropTypes.string.isRequired,
  linkLabel: PropTypes.string.isRequired,
  onLinkClick: PropTypes.func.isRequired
};
